export default __webpack_public_path__ + "static/icons.dark-d0e79822156e1330db0dea0db4c6685f72b7860c0d5f78de46a29b8524ae0179.png";